export default __webpack_public_path__ + "static/media/b_leadership_large.04d37647.png";